export const NONE = { id: 'none', label: 'Nessuna tecnica di procreazione medico-assistita' };
export const OVULATION_INDUCTION = {
  id: 'ovulation_induction',
  label: "Solo trattamento farmacologico per induzione dell'ovulazione",
};
export const IUI = { id: 'iui', label: 'IUI (Intra Uterine Insemination)' };
export const GIFT = { id: 'gift', label: 'GIFT (Gamete Intra Fallopian Transfer)' };
export const IVF = { id: 'ivf', label: 'FIVET (Fertilization In Vitro and Embryo Transfer)' };
export const ICSI = { id: 'icsi', label: 'ICSI (Intra Cytoplasmic Sperm Injection)' };
export const OTHER = { id: 'other', label: 'Altre tecniche' };
